import type { BlockTypePluginOptions } from '@atlaskit/editor-plugin-block-type/types';

interface Props {
	options: never;
}

export function blockTypePluginOptions({}: Props): BlockTypePluginOptions {
	return {
		allowFontSize: true,
		includeBlockQuoteAsTextstyleOption: true,
		lastNodeMustBeParagraph: false,
		allowBlockType: undefined,
	};
}
